export default {
  lotList: [],
  totalLotsPages: 0,
}
